import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/Profile.css';

const FollowersList = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchFollowers = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/${userId}/followers`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setFollowers(response.data);
      } catch (err) {
        setError('Error loading followers');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchFollowers();
  }, [userId]);

  const handleProfileClick = (id) => {
    navigate(`/profile/${id}`);
  };

  if (loading) return <div className="loading">Loading followers...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div style={{maxWidth: '600px', margin: '0 auto', padding: '2rem 1rem'}}>
      <h2 style={{color: '#1dd1a1', marginBottom: '1.5rem'}}>👥 Followers ({followers.length})</h2>
      
      <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
        {followers.length === 0 ? (
          <div style={{textAlign: 'center', color: '#666', padding: '2rem'}}>
            No followers yet
          </div>
        ) : (
          followers.map(follower => (
            <div
              key={follower._id}
              style={{
                background: '#1a1a1a',
                padding: '1rem',
                borderRadius: '8px',
                border: '1px solid #2a2a2a',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}
              onClick={() => handleProfileClick(follower._id)}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = '#1dd1a1'}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = '#2a2a2a'}
            >
              <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: follower.icon ? 'transparent' : 'linear-gradient(135deg, #1dd1a1, #00b894)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '1.5rem',
                flexShrink: 0,
                overflow: 'hidden'
              }}>
                {follower.icon ? (
                  <img 
                    src={`http://localhost:5000${follower.icon}`} 
                    alt="icon"
                    style={{width: '100%', height: '100%', objectFit: 'cover'}}
                  />
                ) : (
                  <>{follower.firstName?.charAt(0)}{follower.lastName?.charAt(0)}</>
                )}
              </div>
              <div style={{flex: 1}}>
                <div style={{fontWeight: 'bold', color: 'white', display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                  <span style={{color: follower.nicknameColor || '#ffffff'}}>
                    {follower.firstName} {follower.lastName}
                  </span>
                  {follower.badge && <span style={{fontSize: '0.9rem'}}>{follower.badge}</span>}
                </div>
                <div style={{color: '#999', fontSize: '0.9rem'}}>
                  @{follower.username}
                </div>
                {follower.bio && (
                  <div style={{color: '#bbb', fontSize: '0.85rem', marginTop: '0.25rem'}}>
                    {follower.bio}
                  </div>
                )}
              </div>
              {follower.isVerified && (
                <span style={{color: '#1dd1a1', fontSize: '1.2rem'}}>✓</span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FollowersList;
